import AirtableTable from "../AirtableTable";
import { Resource } from "../models";
import { airtableFields, airtableTables } from "../schema";

export class ResourceTable extends AirtableTable<Resource> {
  	constructor(instance: any) {
		super(instance, airtableTables.resources);

		this.fields = [
			airtableFields.resources.name, airtableFields.resources.type, airtableFields.resources.resource,
			airtableFields.resources.courses, airtableFields.resources.units, airtableFields.resources.weeks,
			airtableFields.resources.lessons, airtableFields.resources.order, airtableFields.resources.downloadedBy
		]
	}

	getAll = () => {
		return this.list({
			sort: [{
			  field: airtableFields.resources.name,
			  direction: "asc"
			}]
		})
	}

	getByCourse = (course: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.resources.courses] === course));
	}

	getByUnit = (unit: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.resources.units] === unit));
	}

	getByWeek = (week: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.resources.weeks] === week));
	}

	getByLesson = (lesson: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.resources.lessons] === lesson));
	}

	getByUnitAndWeek = (unit: string, week: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.resources.units] === unit && item[airtableFields.resources.weeks] === week));
	}

	getByUnitAndWeekAndLesson = (unit: string, week: string, lesson: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.resources.units] === unit && item[airtableFields.resources.weeks] === week && item[airtableFields.resources.lessons] === lesson));
	}
}
